export default __webpack_public_path__ + "static/media/Mark-2-HUD-01.2e7af1cd.jpg";